//@flow
import loadingAnimation from "./loadingAnimation.json";
export { loadingAnimation };